import React from "react";
import { RedirectIcon } from "../../Assets/Icons";

const ApplicationCard = ({
  showResources = false,
  assignedResources = "",
  name = "",
  description = "",
  logo = "",
  onClick = () => {},
  resourceClick = () => {},
  checkbox = null,
  showCheckbox = false,
  beta = false,
  checked = false,
}) => {
  const handleAppClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const handleResourceClick = (event) => {
    event.stopPropagation();
    if (resourceClick) {
      resourceClick();
    }
  };

  return (
    <div
      className={`app-card ${showResources ? "with-resource" : ""} ${checked ? "checked" : ""} `}
      onClick={handleAppClick}
    >
      <div className="logo-redirect">
        <img src={logo} />
        <div className="extrass">
          {beta && <span className="beta">Beta</span>}
          {showCheckbox && <> {checkbox} </>}
          {!showResources && (
            <span className="redirect">
              <RedirectIcon />
            </span>
          )}
        </div>
      </div>
      <h6 className="title">{name}</h6>
      <p> {description} </p>
      {showResources && (
        <div className="stats">
          <div className="resource">
            <h6>{assignedResources}</h6>
            <p> Assig. Resource </p>
          </div>
          <button className="default-action" onClick={handleResourceClick}>
            View
          </button>
        </div>
      )}
    </div>
  );
};

export default ApplicationCard;
